import { atom, useAtomValue, useSetAtom } from "jotai";

import { LastTrades } from "#/types/perps";

export const lastTradesAtom = atom<LastTrades>({
  trades: {},
  isLoading: false,
});

export const useLastTradesByInstrument = (instrument: string) => {
  const lastTrades = useAtomValue(lastTradesAtom);

  return {
    trades: lastTrades.trades[instrument] ?? [],
    isLoading: lastTrades.isLoading,
  };
};

export const useLastTrades = () => {
  const setLastTrades = useSetAtom(lastTradesAtom);

  return {
    setLastTrades,
  };
};
